<template>
   <v-card v-model="level.dialogValues.dialogShow" data-app="true" >

      <ddoWaiting :value="loading" :message="$t('texts.loading')"/>

      <CardUpdatableHeader :row="row" :level="level">
         <template slot="title_update" slot-scope="props">
            <span class="headline">{{ level.dialogValues.headers.update }}</span>
         </template>
      </CardUpdatableHeader>

      <v-card-text>
         <v-container>
         <v-row>
            <v-col>
               {{ $t('texts.explanation_sync_from_zoho_invoices') }} :
               <v-btn @click="sync_from_zoho()" class="error" rounded>{{ $t('buttons.sync_from_zoho') }}</v-btn>
               <ddoAlert :errors="sync_errors"/>
            </v-col>
         </v-row>

         <v-row>
            <v-col>
               <h2>Format ZOHO</h2>
               <v-textarea
                  v-model="texts.text_input"
                  background-color="grey lighten-2"
               >
               </v-textarea>
            </v-col>
         </v-row>

         <v-row>
            <v-col>
               <b-checkbox v-model="texts.inv_export_to_accounting">{{ $t('texts.inv_export_to_accounting') }}</b-checkbox><br/>
               <b-checkbox v-model="texts.inv_export_include_accounting">{{ $t('texts.inv_export_include_accounting') }}</b-checkbox><br/>
               <v-btn class="primary" rounded :disabled="texts.text_input.length==0" @click="generate_export()">{{ $t('buttons.convert') }}</v-btn>
            </v-col>
         </v-row>

         <v-row>
            <v-col>
               <h2>Suivi</h2>
                  <ddoClientList ref="myTrackingList" :loading="loading" :level="levels[0]" 
                     :columns="levels[0].columns" :options="levels[0].options" :callbacks="levels[0].callbacks"
                     :customSlotNames="levels[0].customSlotNames"
                  >
                     <template v-slot:header="{ errors }">
                        <span></span>
                     </template>

                     <template slot="searchengine" slot-scope="props">
                        <span></span>
                     </template>

                     <template slot="inv_exported_to_accounting" slot-scope="props">
                        <b-checkbox v-if="props.row.inv_exported_to_accounting!=null" disabled v-model="props.row.inv_exported_to_accounting"></b-checkbox>
                     </template>

                     <template slot="inv_total_price" slot-scope="props">
                        <span class="headline" v-if="props.row.inv_total_price!=null">{{ $n(props.row.inv_total_price,'currency') }}</span>
                     </template>

                  </ddoClientList>
            </v-col>
         </v-row>

         <v-row>
            <v-col>
               <h2>Format PRESTIGE</h2>
               <v-textarea
                  v-model="texts.text_output"
                  name="Cliquer sur le bouton pour générer l'export façon Quadratus"
                  background-color="amber lighten-4"
               >
               </v-textarea>
               <v-btn class="primary" rounded :disabled="texts.text_output.length==0" @click="copy_to_clipboard()">{{ $t('buttons.to_clipboard') }}</v-btn>
            </v-col>
         </v-row>
      </v-container>

      </v-card-text>

   </v-card>

</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoWaiting from '@/components/ddoWaiting.vue'
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';
import ddoClientList from '@/components/ddoClientList.vue';

import ZohoObject from '@/plugins/zoho_to_prestige.js';

export default {
   name: 'CardUpdatableMyZoho',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      ddoWaiting,
      CardUpdatableHeader,
      CardUpdatableFooter,
      ddoClientList,
      ZohoObject,
   },

   props: {
   },

   data: function () {
      return {
         file: '',
         loading: false,
         texts: { text_input: '', text_output: '', text_output_decode: '', inv_export_to_accounting: true, inv_export_include_accounting: false },
         sync_errors: [],

         /* 
         * LEVEL 1 : all for ddoClientList : columns, options, callbacks
         */
         levels: [
            {
               api_code: 'invoice',
               api_prefix: 'inv',
               row: {},
               level: 0,
               errors: [],
               columns: [ 'cus_name', 'inv_code', 'ins_name', 'inv_total_price', 'inv_exported_to_accounting', 'inv_tracking_message' ],
               customSlotNames: ['inv_exported_to_accounting','inv_total_price'],
               searchValues: {
               },
               options: {
                  showChildRowToggler: false,
                  withChild: false,
                  hiddenColumns: [],
                  headings: {
                     _pk: i18n.t('headers.actions'),
                     refresh: i18n.t('headers.action_refresh'),
                     inv_name: i18n.t('headers.name'),
                     inv_date: i18n.t('headers.inv_date'),
                     inv_code: i18n.t('headers.inv_code'),
                     cus_name: i18n.t('headers.cus_name'),
                     ins_name: i18n.t('headers.ins_name'),
                     inv_total_price: i18n.t('headers.inv_signed_total_price'),
                     inv_exported_to_accounting: i18n.t('headers._exported'),
                     inv_tracking_message: i18n.t('headers.comments'),
                     _update: i18n.t('headers.updated_on')
                  },
                  rowClassCallback: function(row) {
                     if ( row.inv_tracking_code==0 ) {
                        return "row-ok";
                     } else if ( row.inv_tracking_code==1 ) {
                        return "row-on-warning";
                     } else if ( row.inv_tracking_code==2 ) {
                        return "row-on-error";
                     }
                  },
                  perPage: 100,
                  perPageValues: [100,200,400],
                  texts: {
                  },
                  uniqueKey: 'inv_pk',
                  sortable: ['inv_code','_update'],
                  filterable: false,
                  sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                  columnsDropdown: false,
                  pagination: {
                     chunk: 5,
                     edge: false,
                     nav: 'scroll'
                  },
                  columnsClasses: {
                     inv_total_price: 'text-right',
                  },
                  columnsDisplay: {
                     _update: 'desktop',
                     inv_desc: 'desktop',
                     inv_pk: 'desktop',
                  },
                  customFilters: [],
               },
               callbacks: {
               },
            },
         ],
      }
   },

   created() {
      this.levels[0].callbacks.refresh_rows   = this.refresh_rows_l1;
   },

   mounted() {
   },

   methods: {

      handleFileUpload(){
         this.file = this.$refs.file.files[0];
      },

      submitFile(){
      },

      async refresh_rows_l1(key) {
         let errorinfos = {};
         let api_response = { error: 0, rows: [] };
         return { errorinfos, api_response }
      },

      async sync_from_zoho(level) {
         this.sync_errors = [];
         this.loading = true;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,'probe/SYNC_BM_ZOHO_INVOICES/sync');
         this.loading = false;
         if ( api_response.error==0 ) {
            if ( api_response.rows ) {
               if ( api_response.rows==null || api_response.rows.length==0 ) {
                  this.sync_errors = [ errorinfos ];
               }
               for ( var i=0;i<api_response.rows.length;i++ ) {
                  if ( i==0 ) {
                     this.sync_errors = [ api_response.rows[0] ];
                  } else {
                     this.sync_errors[0].err_value_text += '\n' + api_response.rows[i].err_value_text;
                  }
               }
            }
         } else {
            this.level.errors = [ errorinfos ];
         }
      },

      async generate_export() {
         this.$refs.myTrackingList.rows = [];
         var result = await ZohoObject.methods.build_respond(this.texts.text_input,this.texts.inv_export_to_accounting,this.texts.inv_export_include_accounting,this.$refs.myTrackingList,this);
         result = result.join("\n");
         this.texts.text_output = result;
      },

      analyze_export() {
         var result = ZohoObject.methods.retrieve_fields_in_line(this.texts.text_output);
         this.texts.text_output_decode = JSON.stringify(result);
      },

      copy_to_clipboard() {
         navigator.clipboard.writeText(this.texts.text_output).then(function() {
            /* clipboard successfully set */
         }, function() {
            /* clipboard write failed */
         });
      }
   },
}
</script>

<style>
.row-ok {
   background-color: rgb(204, 247, 204) !important;
}
.row-on-warning {
   background-color: rgb(245, 208, 208) !important;
}
.row-on-error {
   background-color: rgb(219, 75, 75) !important;
}
</style>